import { Link } from "wouter";

export interface BreadcrumbCrumb {
  name: string;
  href?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbCrumb[];
  className?: string;
}

export function Breadcrumbs({ items, className }: BreadcrumbsProps) {
  if (!items || items.length === 0) return null;
  return (
    <nav
      aria-label="Breadcrumb"
      className={
        className ??
        "mb-6 text-xs tracking-widest uppercase text-muted-foreground"
      }
    >
      <ol className="flex flex-wrap items-center gap-x-2 gap-y-1 list-none p-0 m-0">
        {items.map((it, i) => {
          const isLast = i === items.length - 1;
          return (
            <li key={`${it.name}-${i}`} className="flex items-center gap-x-2">
              {it.href && !isLast ? (
                <Link
                  href={it.href}
                  className="hover:text-accent transition-colors"
                >
                  {it.name}
                </Link>
              ) : (
                <span aria-current={isLast ? "page" : undefined}>
                  {it.name}
                </span>
              )}
              {!isLast ? (
                <span aria-hidden="true">/</span>
              ) : null}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
